<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_PRE_TRANSFER')">
    <div class="breadcrumb-area pos-relative">
      <h1>Điều chuyển Merchant</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <div class="box-search bs-left float-left w-auto sm-float-none">
          <div class="form-group">
            <Select2
              @change="onChangeOldSale()"
              v-model="search.saleId"
              placeholder="Nhân viên sale cũ"
              :options="dataOldSale"
            />
          </div>
        </div>
        <div class="box-search bs-right float-right w-auto sm-float-none">
          <div class="form-group">
            <Select2
              placeholder="Nhân viên sale mới"
              :options="dataNewSale"
              @select="selectChangeNewSale($event)"
              v-model="newSale"
            />
          </div>
          <div class="d-inline-block">
            <button
              v-if="this.selected.length > 0 && this.search.saleId"
              class="btn btn-primary hc-37 m-b-10 pt-2"
              data-toggle="modal"
              title="Xác nhận"
              @click="show1 = true"
            >
              Xác nhận
            </button>
            <button
              v-else
              class="btn btn-primary hc-37 m-b-10 pt-2"
              data-toggle="modal"
              title="Xác nhận"
              @click="show2 = true"
            >
              Xác nhận
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- List merchant -->
    <div class="mb-1 ml-1">
      Tổng merchant:
      <strong class="text-primary">{{ pagination.total }}</strong> &nbsp;&nbsp;| &nbsp;&nbsp; Đã
      chọn:
      <strong class="text-primary">{{ selected.length }}</strong>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-bordered" id="tableScroll">
        <thead class="thead-light">
          <tr>
            <th width="50">
              <div class="checkbox text-center">
                <input type="checkbox" v-model="selectAll" />
              </div>
            </th>
            <th scope="col">Thời gian tạo</th>
            <th scope="col">
              <form class="box-search" @submit="submitForm">
                <input v-model="search.textSearch" placeholder="Merchant" />
              </form>
            </th>
            <th scope="col">Địa chỉ</th>
            <th scope="col">
              <div class="dropdown drop-table">
                <Select2
                  v-model="search.regionId"
                  :options="dataConfigRegion"
                  @change="queryProvince($event)"
                  placeholder="Vùng kinh doanh"
                />
              </div>
            </th>
            <th scope="col">
              <div class="dropdown drop-table">
                <Select2
                  v-model="search.cityCode"
                  :options="dataProvince"
                  placeholder="Tỉnh/Thành phố"
                  @change="fetchData()"
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dataCustomer" :key="index" :value="item" class="table-row">
            <td>
              <input type="checkbox" v-model="selected" :value="item" number />
            </td>
            <td>
              {{ item.createAt | formatDay }}, <br />
              {{ item.createAt | formatDate }}
            </td>
            <td>
              <b>{{ item.merchantName }}</b
              ><br />
              <a href="#">{{ item.email }}</a> <br />
              {{ item.mobile }}
            </td>
            <td>{{ item.address + ', ' + item.district + ', ' + item.city }}</td>
            <td>
              Vùng {{ item.regionId | transfromRegion(dataConfigRegion) }}
              <br />
              {{ item.city }}
            </td>
            <td>{{ item.city }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <!--Modal điều chuyển-->
    <b-modal id="modal-scoped" v-model="this.show1">
      <template #modal-header="{ close }">
        <h5>Điều chuyển</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6 class="text-center">
        Bạn có chắc chắn điều chuyển <span>{{ selected.length }}</span> merchant cho nhân viên sales
        {{ newSalerName }} không ?
      </h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button size="sm" variant="primary" @click="confirmTrans()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal thông báo chọn mc, sale mới-->
    <b-modal id="modal-scoped" v-model="this.show2">
      <template #modal-header="{ close }">
        <h5>Điều chuyển</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6 class="text-center">Bạn phải chọn Sale mới, Merchant</h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> OK </b-button>
      </template>
    </b-modal>
    <!--Modal thông báo số lượng điều chuyển thành công/thất bại-->
    <b-modal id="modal-scoped" v-model="this.show3">
      <template #modal-header="{ close }">
        <h5>Điều chuyển</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body text-center">
        <p class="text-center m-t-20 f16">
          Điều chuyển thành công: {{ this.popupInfo.successTrans }}/{{ this.popupInfo.totalTrans }}
          Merchant
        </p>
        <p class="text-center m-t-20 f16">
          Điều chuyển thất bại: {{ this.popupInfo.failedTrans }}/{{ this.popupInfo.totalTrans }}
          Merchant
        </p>
      </div>
      <template #modal-footer="{}">
        <b-button size="sm" variant="light" @click="nextPage()"> OK </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { StaffService } from '@/services/staff.service'
  import { MerchantService } from '@/services/merchant.service'
  import { mapGetters } from 'vuex'

  export default {
    name: 'transMC',
    data() {
      return {
        dataOldSale: [],
        dataNewSale: [],
        dataProvince: [],
        dataConfigRegion: [],
        constDataConfigRegion: [],
        dataCustomer: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 50,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        pagination: {
          total: 0,
        },
        selected: [],
        choose: [],
        show1: false,
        show2: false,
        show3: false,
        newSale: null,
        newSalerName: '',
        popupInfo: {},
      }
    },
    created() {
      this.listOldSale()
      this.getRegions()
    },
    filters: {
      formatDate(date) {
        return date.substring(0, 10)
      },
      formatDay(date) {
        return date.substring(10, 16)
      },
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    watch: {
      'search.limit': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      selectAll: {
        get: function () {
          return this.dataCustomer ? this.selected.length === this.dataCustomer.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataCustomer.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      async fetchData() {
        try {
          if (this.search.regionId === undefined) delete this.search.regionId
          else this.search.searchRegionIds = [this.search.regionId]
          if (this.search.cityCode !== undefined)
            this.search.searchCityCodes = [this.search.cityCode]
          const data = await MerchantService.getlistMCTrans(this.search)
          if (data.success) {
            this.dataCustomer = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async listOldSale() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.dataOldSale = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
                email: e.userName,
                regionIds: e.regionIds,
              }
            })
          }
        } catch (error) {}
      },

      async getListStaffLower(params) {
        try {
          const data = await StaffService.getListLowerGrade(params)
          if (data.data.length > 0) {
            this.dataNewSale = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
                region: e.regionIds,
                email: e.userName,
              }
            })
          }
        } catch (error) {}
      },

      async onChangeOldSale() {
        const dataOldSale = this.dataOldSale.find(a => a.id === this.search.saleId)
        if (dataOldSale) {
          this.getListStaffLower({
            userId: this.search.userId,
            region: dataOldSale.regionIds,
          })
          if (dataOldSale.regionIds) {
            this.search.regionId = dataOldSale.regionIds[0]
            this.queryProvince(this.search.regionId)
            this.mapDataConfigRegion(dataOldSale.regionIds)
          } else {
            delete this.search.regionId
            this.dataConfigRegion = this.constDataConfigRegion
          }
        }
        this.fetchData()
      },

      mapDataConfigRegion(params) {
        this.dataConfigRegion = params.map(a => {
          const data = this.constDataConfigRegion.find(b => b.id === a)
          return data
        })
      },
      async queryProvince(e) {
        if (this.search.saleId) {
          this.getListStaffLower({
            userId: this.search.userId,
            region: [e],
          })
          try {
            const data = await StaffService.getProvinceRegion({ regionId: [e] })
            if (data.data.length > 0) {
              this.dataProvince = data.data.map(e => {
                return { id: e.code, text: e.name }
              })
              this.fetchData()
              this.selected = []
            }
          } catch (error) {}
        }
      },

      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = []
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.constDataConfigRegion = dataRegion
          this.dataConfigRegion = dataRegion
        }
      },

      async selectChangeNewSale({ id, text }) {
        this.newSalerName = text
      },

      async confirmTrans() {
        const newSaler = this.dataNewSale.find(e => e.id === this.newSale)
        const customerTrans = this.selected.map(item => {
          return {
            customerId: item.customerId,
            oldSaleEmail: item.activeSaleEmail,
            oldSaleId: item.activeSaleId,
            oldSaleName: item.activeSaleName,
          }
        })
        const data = await MerchantService.transferMC({
          customerTrans: customerTrans,
          managerEmail: this.dataUser.username,
          managerId: this.dataUser.userId,
          managerName: this.dataUser.name,
          newSaleEmail: newSaler.email,
          newSaleId: newSaler.id,
          newSaleName: newSaler.text,
          regionId: this.search.regionId,
          transferSource: 'MANAGER',
        })
        if (data.success) {
          this.show3 = true
          this.popupInfo = {
            failedTrans: data.data.failedTrans,
            successTrans: data.data.successTrans,
            totalTrans: data.data.totalTrans,
          }
        } else {
          console.log('error response')
        }
      },
      nextPage() {
        if (this.popupInfo.successTrans > 0) {
          this.$router.push('/history-trans')
        } else {
          this.show3 = false
          this.show1 = false
          this.selected = []
          this.fetchData()
        }
      },
    },
  }
</script>
